import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const { processSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (sessionId) {
      processSession(sessionId).then((user) => {
        // Clear hash
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true, state: { user } });
      }).catch(() => {
        navigate('/', { replace: true });
      });
    } else {
      navigate('/', { replace: true });
    }
  }, [processSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 rounded-sm bg-saffron mx-auto mb-4 flex items-center justify-center animate-pulse">
          <span className="text-white font-heading font-bold text-2xl">T</span>
        </div>
        <p className="text-stone-600 dark:text-stone-400">Signing you in...</p>
      </div>
    </div>
  );
}
